import { request } from '../helpers/request';
import { TranslationJob } from '../helpers/types';

export const jobsApi = {
  /** The currently running/queued job for a project, or null. */
  active: (projectId: string) =>
    request<TranslationJob | null>(`/projects/${projectId}/jobs/active`),

  get: (projectId: string, jobId: string) =>
    request<TranslationJob>(`/projects/${projectId}/jobs/${jobId}`),

  startTranslateMissing: (
    projectId: string,
    payload: { languages?: string[]; retranslateRejected?: boolean },
  ) =>
    request<TranslationJob>(
      `/projects/${projectId}/jobs/translate-missing`,
      { method: 'POST', body: payload },
    ),
};
